import { render, staticRenderFns } from "./TicketProcessHead.vue?vue&type=template&id=50b837e8&scoped=true&"
import script from "./TicketProcessHead.vue?vue&type=script&lang=js&"
export * from "./TicketProcessHead.vue?vue&type=script&lang=js&"
import style0 from "./TicketProcessHead.vue?vue&type=style&index=0&id=50b837e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b837e8",
  null
  
)

export default component.exports